import merge from "deepmerge";
import defaultThemeIndex from "gatsby-theme-blog/src/gatsby-plugin-theme-ui/index";
import breakpoints from "./breakpoints";
import colors from "./colors";

export default merge(defaultThemeIndex, {
  breakpoints,
  colors,
});
